import { DeviceTypes, InstallationType } from '@store';
import { AggregatedStatus, GatewayType, TargetRealmType } from '../..';
import {
  InstallationsCollectionQueryParams,
  EquipmentInstallationsResponse,
} from './general-management.model';

import {
  DeviceRoles,
  DeviceStatusType,
  Installation,
  OwnershipType,
  SerialEditorType,
} from '../../models/';

export class MockInstallationsCollection {
  mockLockedDevices: Installation[] = [
    {
      id: 10000018,
      description: '',
      address: {
        street: 'Billwerder Neuer Deich',
        houseNumber: '12',
        zip: '95102',
        city: 'Rehau',
        region: null,
        country: 'de',
        phoneNumber: '+49123456789',
        faxNumber: null,
        geolocation: {
          latitude: 50.200043,
          longitude: 12.025326,
          timeZone: 'Europe/Berlin',
        },
      },
      gateways: [
        {
          serial: '7724820-gw-serial-18',
          version: '506.2244.4.0',
          firmwareUpdateFailureCounter: 0,
          autoUpdate: false,
          createdAt: '2020-05-05T11:58:28.223Z',
          producedAt: '2020-05-05T11:58:28.219Z',
          lastStatusChangedAt: '2023-03-28T08:51:14.952Z',
          aggregatedStatus: AggregatedStatus.Error,
          targetRealm: TargetRealmType.DC,
          devices: [
            {
              gatewaySerial: '7724820-gw-serial-18',
              id: '0',
              boilerSerial: '7722311-device-serial',
              boilerSerialEditor: SerialEditorType.DeviceCommunication,
              bmuSerial: null,
              bmuSerialEditor: null,
              createdAt: '2023-03-21T21:24:34.897Z',
              editedAt: '2023-03-28T08:50:39.742Z',
              modelId: 'E3_Vitodens_200_0620',
              status: DeviceStatusType.Online,
              deviceType: DeviceTypes.Heating,
              roles: [DeviceRoles.E3, DeviceRoles.Boiler],
              isBoilerSerialEditable: true,
            },
            {
              gatewaySerial: '7724820-gw-serial-18',
              id: 'gateway',
              boilerSerial: null,
              boilerSerialEditor: null,
              bmuSerial: null,
              bmuSerialEditor: null,
              createdAt: '2023-03-26T06:37:42.987Z',
              editedAt: '2023-03-26T06:37:45.938Z',
              modelId: 'E3_TCU19_x05',
              status: DeviceStatusType.Online,
              deviceType: DeviceTypes.Tcu,
              roles: [DeviceRoles.E3, DeviceRoles.GatewayTCU],
              isBoilerSerialEditable: true,
            },
          ],
          gatewayType: GatewayType.SA1800019WiFi,
          installationId: 10000018,
          registeredAt: '2023-03-26T06:34:41.840Z',
          description: null,
          otaOngoing: false,
          roles: [],
        },
      ],
      registeredAt: '2023-03-26T06:34:41.832Z',
      updatedAt: '2023-03-26T06:34:41.840Z',
      aggregatedStatus: AggregatedStatus.Error,
      servicedBy: null,
      heatingType: null,
      ownedByMaintainer: false,
      endUserWlanCommissioned: true,
      withoutViCareUser: false,
      installationType: InstallationType.Residential,
      buildingName: null,
      buildingEmail: null,
      buildingPhone: null,
      ownershipType: OwnershipType.ResidentialEndUser,
    },
  ];

  mock(params: InstallationsCollectionQueryParams): EquipmentInstallationsResponse {
    if (params.onlyWithLockedDevices) {
      return {
        cursor: {
          next: '',
        },
        data: this.mockLockedDevices,
      };
    }
  }
}
